import { apiGet, apiPatch, apiPost } from '@/lib/http/client';

import type {
  ActiveCampaignListsResponse,
  ActiveCampaignSeedResponse,
  ActiveCampaignSettingsUpdateRequest,
  ActiveCampaignStatusResponse,
} from '../types';

export async function getActiveCampaignLists(
  orgId: number | string
): Promise<ActiveCampaignListsResponse> {
  return apiGet<ActiveCampaignListsResponse>(
    `/api/orgs/${orgId}/activecampaign/lists/`
  );
}

export async function updateActiveCampaignSettings(
  orgId: number | string,
  body: ActiveCampaignSettingsUpdateRequest
): Promise<ActiveCampaignStatusResponse> {
  return apiPatch<ActiveCampaignStatusResponse>(
    `/api/orgs/${orgId}/activecampaign/settings/`,
    body
  );
}

export async function seedActiveCampaignOutbound(
  orgId: number | string
): Promise<ActiveCampaignSeedResponse> {
  return apiPost<ActiveCampaignSeedResponse>(
    `/api/orgs/${orgId}/activecampaign/seed/`,
    {}
  );
}
